import chat from 'lib/api/chat';
import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import handleErrorMessageAPI from 'global/AlertErrorMessage';
import SUCCESS_MESSAGE from 'constants/successMessage';
import { BulkSharePayload } from '../../../../@types/chat';

interface State {
  isShareModalVisible: boolean;
  recipientName: string | null;
  message: string | null;
}

interface Actions {
  showShareModal(
    recipientName: string,
    communityName: string,
    username: string,
    phone: string,
  ): void;
  sendChat(param: BulkSharePayload): Promise<void>;
  hideShareModal(): void;
}

export const useShareReceipt = create(
  immer<State & Actions>((set, get) => ({
    isShareModalVisible: false,
    recipientName: null,
    message: null,

    showShareModal(recipientName, communityName, username, phone) {
      set((draft) => {
        draft.isShareModalVisible = true;
        draft.recipientName = recipientName;
        // compose message
        draft.message = [
          `Halo ${recipientName},\n`,
          `Saya telah berhasil bergabung dalam komunitas ${communityName}\n`,
          `Stockbit Username: ${username}\n`,
          `No. HP: ${phone}\n`,
          'Mohon undang ke grup diskusi. Terima kasih!',
        ].join(' \n');
      });
    },

    async sendChat(param) {
      const { hideShareModal } = get();
      await chat.sendBulkChat(param);

      handleErrorMessageAPI(
        SUCCESS_MESSAGE.POST_SHARED_SUCCESSFUL,
        SUCCESS_MESSAGE.SNACKBAR_GREEN,
        true,
      );

      hideShareModal();
    },

    hideShareModal() {
      set((draft) => {
        draft.isShareModalVisible = false;
        draft.recipientName = null;
        draft.message = null;
      });
    },
  })),
);
